import React from 'react';
import { Drawer } from 'antd';
import { DSIcon } from '../atoms';

const CustomAppointmentDrawer = ({
  title,
  handleBack,
  handleCancel,
  body,
  showBackButton = true
}) => {

  const getHeight = () => {
    return title == 'Appointment booked' ? '100%' : '91.4%'
  }

  const getTitle = () => {
    return (
      <div className='flex justify-between py-3'>
        <div className='flex items-center justify-center'>
          {showBackButton && (
            <button
              type='button'
              aria-label='Go back'
              onClick={handleBack}
              className='inline-flex h-9 w-9 items-center justify-center rounded-ds-md border border-gray-300 bg-white text-gray-500 transition-colors duration-150 hover:bg-gray-100 hover:text-gray-900'
            >
              <DSIcon name='chevron-left' size={16} />
            </button>
          )}
          <span className='mx-2 text-ts-xl font-fig-semibold text-gray-900'>{title}</span>
        </div>
        <button
          type='button'
          aria-label='Close drawer'
          onClick={handleCancel}
          className='inline-flex h-10 w-10 items-center justify-center rounded-ds-md border border-gray-300 bg-white text-gray-500 transition-colors duration-150 hover:bg-gray-100 hover:text-gray-900'
        >
          <DSIcon name='close' size={16} />
        </button>
      </div>
    )
  }
  
  return (
    <Drawer
    closable={false}
    title={ title == 'Appointment booked' ? null : getTitle() }
    footer={null}
    drawerStyle={{overflowX: 'hidden', background: '#F9FAFB', height: '100%'}}
    bodyStyle={{overflowX: 'hidden', padding : '0px', height: getHeight()}}
    headerStyle={{
          backgroundColor: 'white',
          padding: '0 1.5rem',
        }}
    visible={true}
    width='40%'
    >
      {body}
    </Drawer>
  );
};

export default CustomAppointmentDrawer;
